/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rejectComment: NonNullable<unknown> }} Coinvestments_Tracking_Reject_Tooltipcomment2Inputs */

const en_coinvestments_tracking_reject_tooltipcomment2 = /** @type {(inputs: Coinvestments_Tracking_Reject_Tooltipcomment2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comment: ${i?.rejectComment}`)
};

/**
* | output |
* | --- |
* | "Comment: {rejectComment}" |
*
* @param {Coinvestments_Tracking_Reject_Tooltipcomment2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_reject_tooltipcomment2 = /** @type {((inputs: Coinvestments_Tracking_Reject_Tooltipcomment2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Reject_Tooltipcomment2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_reject_tooltipcomment2(inputs)
});
export { coinvestments_tracking_reject_tooltipcomment2 as "coInvestments_tracking_reject_tooltipComment" }